module.exports = __webpack_public_path__ + "static/media/0006.507c1bec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48012/RAL/0006.png
// module id = 612
// module chunks = 0